export const SUBCRIPTION_RESET = "SUBCRIPTION_RESET" as const;
export const SUBCRIPTION_ALL_SET = "SUBCRIPTION_ALL_SET" as const;
export const SUBCRIPTION_PRODUCT_ALL_SET = "SUBCRIPTION_PRODUCT_ALL_SET" as const;
export const SUBCRIPTION_DENY_SET = "SUBCRIPTION_DENY_SET" as const;
